import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'
import router from '../router/index'
import store from '../store/store'
Vue.use(VueAxios, axios)

// 加密
let Base64 = require('js-base64').Base64;
const encryptionData = Base64.encode(`admin:admin123456`);
export const headers = { Authorization: 'Basic ' + encryptionData }

// 获取token

export function request(config) {
    const instance = axios.create({
        baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : process.env.API_ROOT,
        timeout: 5000,
    });

    //准备请求
    instance.interceptors.request.use(config => {
        let token = localStorage.getItem('token');
        if (token) {
            //config.headers.common['X-Token'] = token;
            config.headers.common['Authorization'] = `Bearer ${token}`; //修改请求头
        }
        return config
    }, err => {
        console.log(err);
    })

    // 请求后
    instance.interceptors.response.use(res => {
        let token;
        if (res.data && res.data.data && res.data.data.token) {
            token = res.data.data.token
        }
        //请求的token && （ 缓存中没有 || 请求的token与缓存的不相同 ）
        if (token && (localStorage.getItem("token") == null || token !== localStorage.getItem("token"))) {
            localStorage.setItem('token', token);
        }
        return res.data;
    }, error => {
        if (error.response && error.response.status === 401) {
            store.commit('tokenInvalid');
            store.commit('infoInvalid');
        }
        return Promise.reject(error.response) // 返回接口返回的错误信息
    })
    return instance(config);
}


// WEBPACK FOOTER //
// ./src/network/request.js